<template>
  <div>
    <FDBannerImg />

    <!-- 导航面包屑 -->
    <div class="navigation">
      <div class="page-cen">
        <div class="navigation-item">
          <router-link to="/home">首页</router-link>
          &nbsp;&gt;
          <span class="active">新闻&通告</span>
        </div>
      </div>
    </div>

    <div class="container">
      <!-- 标签筛选 -->
      <div class="tag">
        <div
          :class="['tag_item', { 'active_tag': tag === item }]"
          v-for="item in tagList"
          :key="item"
          @click="selectTag(item)"
        >
          {{ item }}
        </div>
      </div>

      <!-- 内容列表 -->
      <div class="content">
        <!-- 加载状态 -->
        <div v-loading="loading" element-loading-text="加载中..." class="content_list_wrapper">
          <!-- 数据列表 -->
          <div class="content_list" v-if="total > 0">
            <div
              class="list_item"
              v-for="item in dataList"
              :key="item.id"
              @click="toDetail(item)"
            >
              <div class="title" :class="{ 'has-link': item.linkUrl }">{{ item.title }}</div>
              
              <div class="tags-container">
                <!-- 附件下载标签 -->
                <el-tag
                  v-if="item.fileUrl"
                  type="warning"
                  effect="plain"
                  size="small"
                  @click.stop="downloadFile(item)"
                >
                  附件下载
                </el-tag>

                <!-- 置顶标签 -->
                <el-tag
                  v-if="item.topFlag == 1"
                  type="warning"
                  effect="plain"
                  size="small"
                >
                  置顶
                </el-tag>
              </div>

              <div class="keyword" :class="getKeywordClass(item.keyword)">
                {{ item.keyword }}
              </div>
              
              <div class="date">{{ item.note }}</div>
            </div>
          </div>
        </div>

        <!-- 分页组件 -->
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="currentPage"
          :limit.sync="pageSize"
          @pagination="loadList"
        />

        <!-- 空状态 -->
        <div v-if="total === 0 && !loading" class="empty">
          <img src="@/assets/empty.png" alt="暂无数据" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import FDBannerImg from "@c/FDBannerImg";
import { get } from "@/utils/request";
import { common } from "@/utils/zipdownload";

export default {
  name: "NewsList",
  components: { Pagination, FDBannerImg },
  data() {
    return {
      loading: false,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dataList: [],
      tagList: ["全部"],
      tag: "全部",
    };
  },
  methods: {
    /**
     * 下载文件
     * @param {object} item - 列表项数据
     */
async  downloadFile(item){
  await common({
                url: "common/download/resource",
                params:{resource:encodeURI(item.fileUrl)},
                name:  item.fileName,
            });
            this.$message.success("下载成功！"); 
           },

    /**
     * 选择标签
     * @param {string} item - 标签名称
     */
    selectTag(item) {
      if (this.tag === item) return;
      this.tag = item;
      this.currentPage = 1;
      this.loadList();
    },

    /**
     * 获取关键字对应的样式类
     * @param {string} keyword - 关键字
     * @returns {string} - 类名
     */
    getKeywordClass(keyword) {
      const classMap = {
        "开馆通知": "color1",
        "施工维修": "color2",
        "服务通知": "color3",
        "违规通报": "color4",
        "活动快讯": "color1",
        "馆际通知": "color1",
      };
      return classMap[keyword] || "";
    },

    /**
     * 跳转到详情页
     * @param {object} item - 列表项数据
     */
    toDetail(item) {
      if (item.linkUrl) {
        window.open(item.linkUrl, "_blank");
      } else {
        this.$router.push(`/news/detail/${item.id}`);
      }
    },

    /**
     * 加载列表数据
     */
    async loadList() {
      this.loading = true;
      const params = {
        status: 1,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        menuId: 10023,
      };
      if (this.tag !== "全部") {
        params.keyword = this.tag;
      }
      try {
        const { rows, total } = await get("lib/content/list", params);
        this.dataList = rows || [];
        this.total = total || 0;
      } catch (error) {
        console.error("加载列表失败:", error);
        this.$message.error("数据加载失败，请稍后重试！");
        this.dataList = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },

    /**
     * 获取字典数据
     */
    async getDegreeType() {
      try {
        const { data } = await get("system/dict/data/getList", {
          dictType: "news_type",
        });
        const labels = data.map((item) => item.dictLabel);
        this.tagList.push(...labels);
      } catch (error) {
        console.error("获取新闻类型字典失败:", error);
        this.$message.error("获取分类数据失败！");
      }
    },
  },
  created() {
    this.getDegreeType();
    this.loadList();
  },
};
</script>

<style scoped lang="scss">
.navigation {
  background-color: #f5f5f5;
  padding: 10px 0;
  .page-cen {
    width: 1200px;
    margin: 0 auto;
  }
  .navigation-item {
    font-size: 14px;
    color: #666;
    a {
      color: #666;
      text-decoration: none;
      &:hover {
        color: #004796;
      }
    }
    .active {
      color: #004796;
      font-weight: bold;
    }
  }
}

.container {
  width: 1200px;
  margin: 20px auto;
  padding-bottom: 96px;

  .tag {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 20px;

    .tag_item {
      cursor: pointer;
      border: 1px solid #cdcdcd;
      background: #fff;
      font-size: 12px;
      color: #525252;
      line-height: 29px;
      padding: 0 18px;
      border-radius: 20px;
      transition: all 0.3s;
    }

    .tag_item:hover,
    .active_tag {
      background-color: #004796;
      color: #fff;
      border-color: #004796;
    }
  }

  .content {
    .content_list_wrapper {
      min-height: 200px;
    }

    .content_list {
      .list_item {
        cursor: pointer;
        display: flex;
        align-items: center;
        padding: 20px 0;
        border-bottom: 1px solid #dadada;
        color: #121212;
        transition: color 0.3s;

        &:hover {
          color: #004796;
          .title {
            text-decoration: underline;
          }
        }

        .title {
          flex: 1;
          font-size: 16px;
          font-weight: 500;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .has-link {
          color: #004796;
        }

        .tags-container {
          display: flex;
          gap: 10px;
          margin: 0 20px;
        }
        
        .keyword {
          font-size: 12px;
          border-radius: 30px;
          min-width: 70px;
          line-height: 1;
          padding: 6px 16px;
          text-align: center;
          border: 1px solid #cdcdcd;
          background: #fff;
          color: #525252;
        }

        .date {
          color: #999;
          font-size: 14px;
          margin-left: 20px;
          white-space: nowrap;
        }
      }
    }

    .empty {
      text-align: center;
      padding: 50px 0;
      img {
        width: 150px;
      }
    }
  }
}

.color1 {
  background: #eff1ff;
  color: #0309b8;
  border-color: #0309b8;
}
.color2 {
  background: #d8ffff;
  color: #306eb4;
  border-color: #306eb4;
}
.color3 {
  background: #f6eeff;
  color: #82318e;
  border-color: #82318e;
}
.color4 {
  background: #eee;
  color: #878787;
  border-color: #878787;
}
</style>